import { useEffect, useState } from 'react'

/**
 * Reads the visitor's reduced-motion preference after mount.
 * Starts as false on the server and the first client render so markup always matches.
 */
export const useReducedMotion = (): boolean => {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        const query = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(query.matches)

        update()
        query.addEventListener('change', update)

        return () => query.removeEventListener('change', update)
    }, [])

    return reduced
}
